export const SNAKK_CHAT = {
	SCRIPT_URL: 'https://platform.snakk.ai/chat-embed.js',
	AGENT_ID: '693297ea-cf12-4892-ad74-193380bb58d0',
	SCRIPT_ID: 'snakk-chat-embed',
	// Welcome titles the embed script shows when the chat can't be used (domain not allowed, config failed to load).
	// The script exposes no state for this, so the title is the only signal.
	UNAVAILABLE_TITLES: ['Ikke tillatt', 'Feil ved lasting'],
};
